import { Link, Outlet, useParams } from 'react-router-dom'
import "../Laboratory/Laboratory.scss"
import Header from '../../../Shared-Component/Header/Header'
import Footer from '../../../Shared-Component/Footer/Footer'
import CampusSlashTitle from '../../CampusSharedComponent/CampusTitles/CampusSlashTitle/CampusSlashTitle'
import campuschemistry from "../../../assets/CampuLifeImages/campuschemistry.JPG"
import campushotel from "../../../assets/CampuLifeImages/campushotel.JPG"
import campuscomputer from "../../../assets/CampuLifeImages/campuscomputer.JPG"
import campusviscom from "../../../assets/CampuLifeImages/campusviscom.JPG"
import campusmicro from "../../../assets/CampuLifeImages/campusmicro.JPG"
import campusbio from "../../../assets/CampuLifeImages/campusbio.JPG"
import campusinfo from "../../../assets/CampuLifeImages/campusinfo.JPG"


const Laboratory = () => {
    const { labName } = useParams();
    const labImages = [
        { img: campusinfo, lab: "Computer Lab", linkedto: "Computer_Lab" },
        { img: campuschemistry, lab: "Chemistry Lab", linkedto: "Chemistry_Lab" },
        { img: campuscomputer, lab: "Information Technology Lab", linkedto: "Information_Technology_Lab" },
        { img: campusbio, lab: "Biotechnology Lab", linkedto: "Biotechnology_Lab" },
        { img: campusmicro, lab: "Microbiology Lab", linkedto: "Microbiology_lab" },
        { img: campusviscom, lab: "Visual Design Lab", linkedto: "Visual_Design_Studio" },
        { img: campushotel, lab: "Hotel Management Lab", linkedto: "Hotel_Management_Lab" }
    ]

    return (
        <>
            {(!labName) ?
                <div>
                    <Header />
                    <div className='campusmaincontainer'>
                    <div className='campus-container'>
                        <CampusSlashTitle slashTitle="Laboratory Facility" />
                        <div className='lab-img-main-container'>
                            <div className='lab-img-grid-container'>
                                {
                                    labImages.map((image, index) => (
                                        <Link to={image.linkedto}>
                                            <div key={index} className='lab-img-conatiner'>
                                                <img src={image.img}></img>
                                                <div className='lab-img-caption'>
                                                    <p>{image.lab}</p>
                                                </div>
                                            </div>
                                        </Link>
                                    ))
                                }
                            </div>
                        </div>
                        </div>
                        <Footer />
                    </div>
                </div>
                : <><Outlet /></>
            }

        </>
    )
}

export default Laboratory